<template>
  <transition name="fade">
    <FullScreenModal class="cloth-select-modal" v-if="modalShow" title="選取單品" @back="backClicked">
      <template #right-top>
        <b-button class="skip-btn" variant="link" @click.prevent="skipClicked">
          <span>略過</span>
        </b-button>
      </template>
      <div class="sticky-nav">
        <h4 class="fs-20px">從衣櫥中挑選單品</h4>
      </div>
      <div class="closet-list">
        <ClothPickerFromBoth
            ref="clothPicker"
            :cloths="cloths"
            v-model="selectedId"
        />
      </div>
      <CustomModalFooter class="collect-footer d-flex justify-content-between align-items-center flex-nowrap">
        <div class="info">
          <div class="fs-16px">
            <span>已選取 </span>
            <span v-text="selectedLength"></span>
            <span> 件</span>
          </div>
        </div>
        <b-button variant="primary" :disabled="confirmButtonDisabled" @click="confirmClicked">
          <span>完成</span>
        </b-button>
      </CustomModalFooter>
    </FullScreenModal>
  </transition>
</template>

<script>
import FullScreenModal from '@/components/FullScreenModal';
import ClothPickerFromBoth from '../clothList/ClothPickerFromBoth.vue';
import CustomModalFooter from "@/components/CustomModalFooter.vue";

export default {
  name: 'ClothSelectModal',

  components: {
    CustomModalFooter,
    FullScreenModal,
    ClothPickerFromBoth,
  },

  props: {
    value: {
      type: Boolean,
    },

    source: {
      type: String,
      default: 'closet',
      validator(value) {
        return ['closet', 'drawer'].includes(value)
      }
    },

    cloths: {
      type: Array,
      required: true,
    },

    title: {
      type: String,
      default: '從衣櫥中挑選單品'
    }
  },

  data() {
    return {
      selectFrom: 'closet',
      selectedId: [],
    };
  },

  computed: {
    modalShow: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    },

    selectedLength() {
      return this.selectedId.length;
    },

    confirmButtonDisabled() {
      return this.selectedLength === 0;
    }
  },

  methods: {
    backClicked() {
      this.$emit('back');
    },

    skipClicked() {
      this.$emit('skip');
    },

    confirmClicked() {
      this.$emit('confirm', [...this.selectedId]);
    },

    reset() {
      this.selectedId = [];
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
.cloth-select-modal {
  .skip-btn.btn-link {
    color: $color-input-grey;
    padding: .7rem .5rem;
  }
  .sticky-nav {
    position: sticky;
    top: 0;
    z-index: 50;
    padding-top: 1.5rem;
    background-color: #fff;
  }
  .h4.fs-20px {
    margin-bottom: .125rem;
  }
  .btn-link {
    padding: 0;
  }
  .option-nav {
    .btn-link {
      padding: 10px;
    }
  }
  .closet-list {
    padding: 0 0 3rem;
  }
  .closet-item {
    cursor: pointer;
    position: relative;
    background: $color-image-background;
    width: 100%;
    padding-top: 100%;
    border-radius: .5rem;
    overflow: hidden;
    filter: brightness(.8);
    &.selected {
      filter: brightness(1);
      .check-icon {
        background: $color-status-success;
      }
    }
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .lock {
      position: absolute;
      top: .25rem;
      right: .125rem;
    }
    .check-icon {
      position: absolute;
      bottom: .25rem;
      right: .25rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background: $color-input-grey;
      width: 1rem;
      height: 1rem;
      border-radius: 100px;
      svg {
        color: $typography-primary-inverted;
      }
    }
  }
}
</style>
<style lang="scss">
@import "src/assets/scss/basic";
.cloth-select-modal {
  .box .box-body {
    padding: 0 1rem 5rem;
  }
  .cloth-category-tabs {
    margin-left: -.25rem;
    margin-right: -1rem;
    .category-tab {
      font-size: .875rem;
      padding: .125rem .5rem;
      margin: .5rem .5rem;
    }
  }
  .collect-footer {
    gap: 1rem;
    .btn.btn-primary {
      width: 10rem;
    }
  }
}
</style>